import BaseRequest from "@services/http/BaseRequest";
import { BaseResponse } from "@services/http/responses/BaseResponse";
import useApiRequests, {
  RequestOptions,
  testRequestEx,
} from "@services/http/useApiRequest";

export const castResponse = <R extends BaseResponse>(r: BaseResponse) => r as R;

export interface RequestTyper<Q extends any[], R extends BaseResponse> {
  makeRequest(...args: Q): BaseRequest | void;
  makeResponse?(r: BaseResponse): R;
}

const useTypedRequest = <Q extends any[], R extends BaseResponse>(
  typer: RequestTyper<Q, R>,
  ops?: RequestOptions
) => {
  const { enqueue, isLoading: loading } = useApiRequests();

  const request = async (...params: Q): Promise<R | void> => {
    const req = typer.makeRequest(...params);
    if (!req) return;
    const r = await enqueue(req, ops);
    if (!r) return;
    return typer.makeResponse ? typer.makeResponse(r) : (r as R);
  };

  return { request, loading };
};

//  первые попытки тесто-пригодности, без хуков
export const useTestTypedRequest = <Q extends any[], R extends BaseResponse>(
  typer: RequestTyper<Q, R>,
  ops?: RequestOptions
) => {
  const request = async (...params: Q): Promise<R | void> => {
    const r = await testRequestEx(typer.makeRequest(...params));
    if (!r) return;
    return typer.makeResponse ? typer.makeResponse(r as R) : (r as R);
  };
  return { request, loading: false };
};

export default useTypedRequest;
